import { Box, Typography } from '@mui/material';
import { EventSettingsSection } from 'components/settings/sections/EventSettingsSection';
import { GeneralSettingsSection } from 'components/settings/sections/GeneralSettingsSection';
import { LibrarySettingsSection } from 'components/settings/sections/LibrarySettingsSection';
import { useTranslation } from 'react-i18next';

export function Settings() {
  const { t } = useTranslation();

  return (
    <>
      <Typography variant="h1" gutterBottom>
        {t('settings', 'Settings')}
      </Typography>
      <Box
        sx={{
          columnCount: { xs: 1, md: 2 },
          columnGap: 2,
        }}
      >
        <Box sx={{ breakInside: 'avoid', mb: 2 }}>
          <GeneralSettingsSection />
        </Box>
        <Box sx={{ breakInside: 'avoid', mb: 2 }}>
          <EventSettingsSection />
        </Box>
        <Box sx={{ breakInside: 'avoid', mb: 2 }}>
          <LibrarySettingsSection />
        </Box>
      </Box>
    </>
  );
}
